import { Record, Map } from 'immutable';
import { fetchSurveyFormActions, submitSurveyFormActions } from './survey.actions';
import * as api from '../api';

export const SurveyState = Record({
  /** the survey form indexed by token */
  surveyForms : Map({}),
  /** state of form submission indexed by the id of the survey token */
  formSubmission: Map({}),
});

export const surveyReducer = (initialState = new SurveyState(), action) => {

  var state = initialState;

  if(action.token) {
    state = state.setIn(['surveyForms', action.token],
      api.apiCallReducer(state.getIn(['surveyForms', action.token]), action, fetchSurveyFormActions));

    state = state.setIn(['formSubmission', action.token],
      api.apiCallReducer(state.getIn(['formSubmission', action.token]), action, submitSurveyFormActions));
  }

  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/survey/survey.reducer.js